import React from 'react';
import Tabs from '@material-ui/core/Tabs';
import MaterialTab from '@material-ui/core/Tab';
import Paper from '@material-ui/core/Paper';
import { Grid } from '@material-ui/core';
import PropTypes from 'prop-types';
import { useAuthContext } from 'hooks/useAuthContext';

class Tab {
  constructor({ label, value, scope, action }) {
    this.label = label;
    this.value = value;
    this.scope = scope;
    this.action = action;
  }
};

const TabbedPage = ({ tabs, activeTab, tabSetterFunc, children, elevation=1 }) => {
  const { role } = useAuthContext();

  const renderedTabs = tabs.map(tab => {
    if(!tab.scope && !tab.action) {
      return <MaterialTab label={tab.label} value={tab.value} key={tab.value} />
    } else {
      return role.check(tab.scope, tab.action) ? <MaterialTab label={tab.label} value={tab.value} key={tab.value} /> : null;
    };
  });

  return (
    <Grid container direction="row">
      <Grid item xs>
        <Paper elevation={elevation}>
          {
            role &&
            <Tabs
              value={activeTab}
              textColor="primary"
              indicatorColor="primary"
              onChange={(event, value) => tabSetterFunc(value)}
            >
              {renderedTabs}
            </Tabs>
          }
          {children}
        </Paper>
      </Grid>
    </Grid>
  )
};

TabbedPage.propTypes = {
  tabs: PropTypes.arrayOf(PropTypes.instanceOf(Tab)).isRequired,
  activeTab: PropTypes.string.isRequired,
  tabSetterFunc: PropTypes.func.isRequired,
  children: PropTypes.node
};

export { TabbedPage, Tab };